import type { InboxGroup, InboxProvider } from "../api/connectionHub.types";
import { INBOX_ACTION, INBOX_PROVIDER } from "../api/connectionHub.types";
import { CONNECTION_STATUS } from "../constants/connectionStatus.constants";

const STILL_FORWARDING = new Set<string>([
  CONNECTION_STATUS.FORWARDING_REQUIRED,
  CONNECTION_STATUS.CONFIRMING_FORWARDING,
  CONNECTION_STATUS.FORWARDING_VERIFICATION_FAILED,
]);

/** forwarding/filter are the setup confirms; verify is the recheck's "I've Set Up Filter / Rules". */
export type InboxStepAction = "forwarding" | "filter" | "verify";

/** Gmail's forwarding confirm only waits on Gmail's confirmation mail; every other step starts verification. */
export const startsVerification = (provider: InboxProvider, action: InboxStepAction): boolean =>
  action !== "forwarding" || provider !== INBOX_PROVIDER.GMAIL;

/**
 * The card as it will look once the last confirm (Gmail filter, Outlook rule) starts verification, so it can
 * switch to the processing rows on click instead of after the round trip. `connectionIds` scopes it to one
 * Outlook rule; omitted or empty means the whole inbox. The server's card replaces this as soon as it lands.
 */
export const markVerifying = (group: InboxGroup, connectionIds?: string[]): InboxGroup => {
  const scope = connectionIds?.length ? new Set(connectionIds) : null;
  const covers = group.covers.map((cover) => (!scope || scope.has(cover.connectionId)
    ? { ...cover, status: CONNECTION_STATUS.VERIFYING, lastError: null, fixPath: null }
    : cover));
  const allStarted = covers.every((cover) => !STILL_FORWARDING.has(cover.status));

  return {
    ...group,
    covers,
    status: allStarted ? CONNECTION_STATUS.VERIFYING : group.status,
    actions: allStarted
      ? group.actions.filter((action) => action !== INBOX_ACTION.CONFIRM_FILTER && action !== INBOX_ACTION.CONFIRM_FORWARDING)
      : group.actions,
    inbox: { ...group.inbox, forwardingError: null },
  };
};
